import {NgModule} from '@angular/core';
import {AsaxResultTableComponent} from './asax-result-table.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';
import {SearchTableModule} from './search-table/search-table.module';
import {VoTableModule} from "./vo-table/vo-table.module";

@NgModule({
  declarations: [
    AsaxResultTableComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    SearchTableModule,
    VoTableModule
  ],
  exports: [
    AsaxResultTableComponent
  ]
})
export class AsaxResultTableModule {
}
